import { render, staticRenderFns } from "./vehicleDetail.vue?vue&type=template&id=2673ce97&scoped=true"
import script from "./vehicleDetail.vue?vue&type=script&lang=js"
export * from "./vehicleDetail.vue?vue&type=script&lang=js"
import style0 from "./vehicleDetail.vue?vue&type=style&index=0&id=2673ce97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673ce97",
  null
  
)

export default component.exports